<p>full-screen-overlay works!</p>
